import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';

const createSwitchControlMulti = ({
	namespace,
	stateNodeName,
	defaultValues,
	mainFilterSettings
}) => {
	// action types
	const CHOOSE_FILTER = `${namespace}/${stateNodeName}-choose-filter`;
	const SET_FROM_MAIN_FILTER = `${namespace}/${stateNodeName}-set-from-main-filters`;
	const SET_VALUES = `${namespace}/${stateNodeName}-set-values`;

	// init state
	const initialState = {
		filters: defaultValues
	};

	// actions
	const actions = {
		switchControlMultiChooseFilter: filterValue => (dispatch, getState) => {
			dispatch({
				type: CHOOSE_FILTER,
				payload: filterValue
			});

			if (mainFilterSettings) {
				const { relationName, inst: { actions } } = mainFilterSettings;
				const { filters } = getState()[namespace][stateNodeName];
				const getActiveFilters = filters.filter(entity => entity.active && entity.name !== 'all');
				const valuesList = getActiveFilters.map(entity => ({ value: entity.name, label: entity.name }));

				const removeFilter = removeMainFilterByName(relationName, actions);
				const setFilterValues = setFilterValuesByName(relationName, actions, valuesList);

				!getActiveFilters.length
					? removeFilter(dispatch)
					: setFilterValues(dispatch);

			}
		},

		switchControlMultiSetValueFromFilter: selectedFilters => ({
			type: SET_FROM_MAIN_FILTER,
			payload: selectedFilters
		}),

		switchControlMultiSetValues: values => ({
			type: SET_VALUES,
			payload: values
		})
	};

	// reducers
	const reducers = {
		[CHOOSE_FILTER]: (state, action) => {
			const { filters } = cloneDeep(state[stateNodeName]);

			let newFilters = filters.map(entity => {
				let active = false;

				if (action.payload === 'all') {
					active = entity.name === action.payload;
				} else {
					active = entity.name === 'all'
						? false
						: entity.name === action.payload ? !entity.active : entity.active;
				}

				return {
					...entity,
					active
				};
			});

			const shouldAddedInitial = !newFilters.filter(entity => entity.active).length;

			return {
				...state,
				[stateNodeName]: {
					...state[stateNodeName],
					filters: !shouldAddedInitial ? newFilters : initialState.filters
				}
			};
		},

		[SET_FROM_MAIN_FILTER]: (state, actions) => {
			const { filters } = state[stateNodeName];
			const selectedPriorityFilter = actions.payload.length
				? find(actions.payload, entity => entity.name === mainFilterSettings.relationName)
				: {};

			const newFilters = filters.map(entity => {
				let active = false;

				if (isEmpty(selectedPriorityFilter)) {
					active = entity.name === 'all';
				} else {
					active = entity.name === 'all'
						? false
						: !!find(selectedPriorityFilter.value, filter => filter.value === entity.name);
				}

				return {
					...entity,
					active
				};
			});

			return {
				...state,
				[stateNodeName]: {
					...state[stateNodeName],
					filters: newFilters
				}
			};
		},

		[SET_VALUES]: (state, action) => {
			const { filters } = cloneDeep(state[stateNodeName]);

			const newFilters = filters.map(entity => {
				const shouldBeActive = action.payload.indexOf(entity.name) > -1;
				return {
					...entity,
					active: shouldBeActive
				};
			});

			return {
				...state,
				[stateNodeName]: {
					...state[stateNodeName],
					filters: newFilters
				}
			};
		}
	};

	// selectors
	const selectors = {
		getControls: state => state[namespace][stateNodeName].filters
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createSwitchControlMulti;

// functions
const removeMainFilterByName = (filterName, filterActions) => dispatch => {
	dispatch(filterActions.clearFilterValue(filterName));
	dispatch(filterActions.deleteFilterByName(filterName));
};

const setFilterValuesByName = (filterName, filterActions, valuesList) => dispatch => {
	removeMainFilterByName(filterName, filterActions)(dispatch);
	dispatch(filterActions.addFilter(filterName));
	dispatch(filterActions.addFilterValue(valuesList, filterName));
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/switch-control/multi/index.js